export default "__VITE_ASSET__BJbg04Mw__"